import { render, staticRenderFns } from "./Component-RealtimeCallWin.vue?vue&type=template&id=2a3ac364&"
import script from "./Component-RealtimeCallWin.vue?vue&type=script&lang=js&"
export * from "./Component-RealtimeCallWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports